import { css } from '@emotion/react';

import { theme } from '@adflow/frontend/ui-theme';

export const tableHeaderHeight = 33;

export const styles = {
	/**
	 * Provide a positioned ancestor that does not scroll so
	 * that the floatingColumnButton stays in the top right
	 * of the table and does not move when the table is scrolled.
	 */
	tableContainer: css({
		position: 'relative',
		flexGrow: '1',
		flexShrink: '1',
		minHeight: '0px',
	}),
	table: css({
		display: 'flex',
		flexDirection: 'column',
		'[data-sticky-cell]': {
			position: 'sticky',
		},
		'[data-sticky-last-left-cell]': css({
			borderColor: theme.colors.input.border,
			borderRightWidth: '1px',
			boxShadow: '0px 0px 8px 2px #0a0a0a1a',
			clipPath: 'inset(0px -15px 0px 0px)',
		}),
	}),
	header: css({
		position: 'sticky',
		top: '0px',
		zIndex: 1,
		minWidth: 'min-content',
		'&:hover #resizer': css({ opacity: '1' }),
	}),
	body: css({
		position: 'sticky',
		left: '0px',
		flexGrow: '1',
		minWidth: 'min-content',
	}),
	allCells: css({ overflow: 'hidden' }),
	headerCell: css({
		backgroundColor: theme.colors.background.tableHeader,
		borderColor: theme.colors.input.border,
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		borderBottomWidth: '1px',
		height: tableHeaderHeight,
		position: 'relative',
	}),

	headerCellArchived: css({ background: '#dddddd66' }),
	// Add flexbox to default
	normalCell: css({
		backgroundColor: theme.colors.background.default,
		color: theme.colors.text.primary,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		height: '3.5rem',

		borderColor: theme.colors.input.border,
		borderBottomWidth: '1px',
	}),
	normalCellArchived: css({
		backgroundColor: theme.colors.background.paperTransparent,
	}),

	tableRow: css({
		color: theme.colors.text.primary,
		display: 'flex',
		flexDirection: 'column',
	}),
	resizerContainer: (sticky: boolean, hidden: boolean) =>
		css({
			display: 'flex',
			justifyContent: 'center',
			width: '1.25rem',

			// Position on the right edge of the column.
			position: 'absolute',
			transform: 'translateX(50%)',
			right: 0,
			top: 0,
			bottom: 0,

			userSelect: 'none',
			touchAction: 'none',
			backgroundColor: 'transparent',
			zIndex: 1,
			visibility: hidden ? 'hidden' : 'visible',
		}),
	resizer: (isResizing: boolean) =>
		css(
			{
				backgroundColor: theme.colors.input.border,
				height: '100%',
				opacity: '0.3',
			},
			isResizing &&
				css({
					backgroundColor: theme.colors.text.tableHeader,
				}),
			{ width: 2 }
		),
};
